/**
 * Legal disclaimer banners shown on entity lists, rosters, and leaderboards.
 * Non-dismissible as per the v5.7.24 risk assessment.
 *
 * v6.2 (2026-06): hardened per the pre-launch counsel brief — adds AI-artwork,
 * scores-are-not-opinions, Fantasy-Dollars-no-cash-value and age framing. The
 * SweepstakesDisclaimer was removed earlier; the platform runs no sweepstakes.
 */
import { Link } from 'react-router-dom';
import { AFFILIATION_DISCLAIMER } from '../legal/legalContent';
export function LegalDisclaimer({ variant = 'compact' }) {
  if (variant === 'full') {
    return (
      <div className="bg-secondary/30 border border-border/40 rounded-xl p-3 text-xs text-muted-foreground leading-relaxed" data-testid="legal-disclaimer">
        <p className="font-semibold text-xs mb-1">Legal Notice</p>
        <p>
          Fantasy World Star is an independent editorial fantasy game by Gazumba
          Games LLC, based on publicly available information. The names of real
          public figures are used under nominative fair use for news-based
          entertainment; no person, team, league, company, or platform shown is
          affiliated with, sponsors, or endorses this game. All scores derive only
          from objective, verifiable public events and are not opinions, ratings
          of character, or endorsements. Portraits are AI-generated stylized
          illustrations — not photographs or real likenesses. Fantasy Dollars (₣)
          are virtual points with no cash value and cannot be redeemed or
          transferred. No prizes, entry fees, sweepstakes, or gambling. Adults 18+.
          Attention data is sourced from the X (Twitter) API (paid license),
          Wikipedia, and YouTube; these names identify data sources only — no
          affiliation with or endorsement by X Corp., the Wikimedia Foundation,
          or Google LLC.
        </p>
      </div>
    );
  }

  return (
    <p className="text-xs text-muted-foreground text-center px-4 leading-relaxed" data-testid="legal-disclaimer-compact">
      Fantasy entertainment game based on public information. Not affiliated with or endorsed by anyone shown. AI-stylized art, not real likenesses. No prizes or gambling.
    </p>
  );
}

export function EntityOptOutNotice() {
  return (
    <p className="text-xs text-muted-foreground text-center mt-2" data-testid="entity-opt-out-notice">
      Are you this person? Request removal at <a href="/legal/takedown" className="underline">our opt-out form</a> or <a href="mailto:contact@gazumbagames.com" className="underline">contact@gazumbagames.com</a>.
    </p>
  );
}

/**
 * Unified person-profile / Explore affiliation disclaimer (owner-finalized
 * 2026-06). Backed by the single AFFILIATION_DISCLAIMER source of truth so web
 * + mobile read identically. The trailing email + "request removal" render as
 * links on web; mobile shows the flattened `.full` text.
 */
export function AffiliationDisclaimer({ testId = 'affiliation-disclaimer', className = '' }) {
  return (
    <p
      className={`text-xs text-muted-foreground text-center px-4 leading-relaxed ${className}`}
      data-testid={testId}
    >
      {AFFILIATION_DISCLAIMER.prefix}{' '}
      <a href="mailto:contact@gazumbagames.com" className="underline">contact@gazumbagames.com</a>
      {' '}·{' '}
      <Link to="/legal/takedown" className="underline" data-testid="affiliation-request-removal">request removal</Link>
    </p>
  );
}
